import * as i0 from "@angular/core";
export class CacheStorageService {
    constructor() {
    }
    get(key) {
        return Promise.resolve(JSON.parse((localStorage.getItem(key))));
    }
    set(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
        return this.get(key);
    }
    remove(key) {
        return localStorage.removeItem(key);
    }
}
CacheStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CacheStorageService_Factory() { return new CacheStorageService(); }, token: CacheStorageService, providedIn: "root" });
